const state = {
  message: ''
}

const mutations = {
  SET_MESSAGE: (state, message) => {
    state.message = message
  }
}

const actions = {
  changeMessage ({commit}, info) {
    commit('SET_MESSAGE', info)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js